import { useState, useEffect } from "react";
import {
  AiFillEdit,
  AiFillDelete,
  AiOutlinePlus,
  AiOutlineArrowUp,
  AiOutlineArrowDown,
} from "react-icons/ai";
import "../assets/css/components.css";
import {
  MdCancel,
  MdExpandLess,
  MdExpandMore,
  MdOutlineNavigateNext,
  MdOutlineNavigateBefore,
} from "react-icons/md";
import { Textbox } from "../components/textbox";
import {
  TbLayoutSidebarLeftExpandFilled,
  TbLayoutSidebarRightExpandFilled,
} from "react-icons/tb";

export const TableList = ({
  loading = false,
  list,
  handlePopupDialogOpen,
  handlePreviewPopupDialogOpen,
  deletePromise,
  isPreview = false,
  isEditable = true,
  rowsPerPage = 10,
}) => {
  const [dataList, setDataList] = useState([]);
  const [columnName, setColumnName] = useState([]);
  const [filteredDataList, setFilteredDataList] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectToggle, setSelectToggle] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });
  const [searchKeyword, setSearchKeyword] = useState("");
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [showLastFourColumns, setShowLastFourColumns] = useState(false);
  const lastFourFields = [
    "createdBy",
    "createdDate",
    "lastModifiedBy",
    "lastModifiedDate",
  ];
  const totalPages = Math.ceil(filteredDataList.length / rowsPerPage);
  const startRow = (currentPage - 1) * rowsPerPage;
  const paginatedData = filteredDataList.slice(
    startRow,
    startRow + rowsPerPage
  );
  const applyFilters = () => {
    setFilteredDataList(
      dataList.filter((data) => {
        return Object.keys(data).some((key) => {
          const value = data[key];
          return (
            value &&
            value.toString().toLowerCase().includes(searchKeyword.toLowerCase())
          );
        });
      })
    );
  };
  const handleCheckboxChange = (event, id) => {
    if (event.target.checked) {
      setSelectedRows((prevSelected) => [...prevSelected, id]);
    } else {
      setSelectedRows((prevSelected) =>
        prevSelected.filter((rowId) => rowId !== id)
      );
    }
  };
  const handleSelectToggle = () => {
    setSelectToggle(!selectToggle);
  };
  const handleDeleteSelected = () => {
    deletePromise(selectedRows, () => {
      setDataList((prevList) =>
        prevList.filter((item) => !selectedRows.includes(item.id))
      );
      setSelectedRows([]);
      setSelectToggle(false);
      return "Selected item deleted successfully.";
    });
  };
  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    const sortedList = [...filteredDataList].sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === "ascending" ? -1 : 1;
      }
      if (a[key] > b[key]) {
        return direction === "ascending" ? 1 : -1;
      }
      return 0;
    });
    setFilteredDataList(sortedList);
    setSortConfig({ key, direction });
  };
  const renderSortIcon = (key) => {
    if (sortConfig.key === key) {
      if (sortConfig.direction === "ascending") {
        return <AiOutlineArrowUp />;
      } else {
        return <AiOutlineArrowDown />;
      }
    }
    return null;
  };
  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };
  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };
  const arrangeColumnName = () => {
    let columns = list.length > 0 ? Object.keys(list[0]) : [];
    setColumnName([
      "id",
      ...columns.filter((col) => ![...lastFourFields, "id"].includes(col)),
      ...lastFourFields,
    ]);
  };
  useEffect(() => {
    setDataList(
      [...list].sort((a, b) => {
        const dateA = new Date(a.lastModifiedDate);
        const dateB = new Date(b.lastModifiedDate);
        return dateB - dateA;
      })
    );
    arrangeColumnName();
  }, [list]);
  useEffect(() => {
    applyFilters();
  }, [searchKeyword, dataList]);
  useEffect(() => {
    setCurrentPage(1);
  }, [filteredDataList]);

  return (
    <div>
      {!isPreview && (
        <div>
          <div className="collapse-button" onClick={toggleCollapse}>
            Advance Search
            {isCollapsed ? <MdExpandMore /> : <MdExpandLess />}
          </div>
          {!isCollapsed && (
            <div className="search">
              <Textbox
                name="searchKeyword"
                type="text"
                placeholder="Search"
                value={searchKeyword}
                onChange={(e) => setSearchKeyword(e.target.value)}
              />
            </div>
          )}
          <hr />
        </div>
      )}
      {isEditable && (
        <div className="table-action">
          {!isPreview && (
            <AiOutlinePlus
              onClick={() => handlePopupDialogOpen(null)}
              className={`table-icon ${loading ? "disabled" : ""}`}
            />
          )}
          {!selectToggle ? (
            <AiFillEdit
              onClick={handleSelectToggle}
              className={`table-icon ${loading ? "disabled" : ""}`}
            />
          ) : (
            <MdCancel
              onClick={handleSelectToggle}
              className={`table-icon ${loading ? "disabled" : ""}`}
            />
          )}
          <AiFillDelete
            onClick={handleDeleteSelected}
            className={`table-icon ${loading || selectedRows.length === 0 ? "disabled" : ""}`}
            hidden={!selectToggle}
          />
          {!isPreview &&
            (showLastFourColumns ? (
              <TbLayoutSidebarRightExpandFilled
                onClick={() => setShowLastFourColumns(!showLastFourColumns)}
                className={`table-icon ${loading ? "disabled" : ""}`}
              />
            ) : (
              <TbLayoutSidebarLeftExpandFilled
                onClick={() => setShowLastFourColumns(!showLastFourColumns)}
                className={`table-icon ${loading ? "disabled" : ""}`}
              />
            ))}
        </div>
      )}
      <table className="table-list">
        <thead>
          <tr>
            <th hidden={!selectToggle}></th>
            <th>No</th>
            {columnName.map(
              (data) =>
                (!lastFourFields.includes(data) || showLastFourColumns) && (
                  <th
                    className="clickable-text"
                    onClick={() => handleSort(data)}
                    key={data}
                  >
                    {data} {renderSortIcon(data)}
                  </th>
                )
            )}
          </tr>
        </thead>
        <tbody>
          {paginatedData.length === 0 ? (
            <tr>
              <td colSpan={columnName.length + 2}>No Records Found</td>
            </tr>
          ) : (
            paginatedData.map((data, index) => (
              <tr key={data.id ?? index}>
                <td hidden={!selectToggle}>
                  <input
                    type="checkbox"
                    checked={selectedRows.includes(data.id)}
                    onChange={(e) => handleCheckboxChange(e, data.id)}
                  />
                </td>
                <td>{startRow + index + 1}</td>
                {columnName.map(
                  (column) =>
                    (!lastFourFields.includes(column) ||
                      showLastFourColumns) && (
                      <td key={column}>
                        {column === "id" ? (
                          <div
                            onClick={() =>
                              !isPreview ? handlePopupDialogOpen(data) : {}
                            }
                            className={!isPreview ? "clickable-text" : ""}
                          >
                            {data[column] ?? "N/A"}
                          </div>
                        ) : column === "info" ? (
                          <div
                            onClick={() =>
                              handlePreviewPopupDialogOpen(data.info)
                            }
                            className="clickable-text"
                          >
                            Preview
                          </div>
                        ) : column === "galleries" ? (
                          <div
                            onClick={() =>
                              handlePreviewPopupDialogOpen(
                                data.galleries,
                                "image"
                              )
                            }
                            className="clickable-text"
                          >
                            Preview
                          </div>
                        ) : column === "banners" ? (
                          <div
                            onClick={() =>
                              handlePreviewPopupDialogOpen(
                                data.banners,
                                "image"
                              )
                            }
                            className="clickable-text"
                          >
                            Preview
                          </div>
                        ) : column === "videos" ? (
                          <div
                            onClick={() =>
                              handlePreviewPopupDialogOpen(data.videos, "video")
                            }
                            className="clickable-text"
                          >
                            Preview
                          </div>
                        ) : column === "menus" ? (
                          <div
                            onClick={() =>
                              handlePreviewPopupDialogOpen(data.menus, "image")
                            }
                            className="clickable-text"
                          >
                            Preview
                          </div>
                        ) : column === "merchandises" ? (
                          <div
                            onClick={() =>
                              handlePreviewPopupDialogOpen(
                                data.merchandises,
                                "image"
                              )
                            }
                            className="clickable-text"
                          >
                            Preview
                          </div>
                        ) : column === "lineUps" ? (
                          <div
                            onClick={() =>
                              handlePreviewPopupDialogOpen(
                                data.lineUps,
                                "image"
                              )
                            }
                            className="clickable-text"
                          >
                            Preview
                          </div>
                        ) : column === "logo" ? (
                          <div
                            onClick={() =>
                              handlePreviewPopupDialogOpen(data.logo, "image")
                            }
                            className="clickable-text"
                          >
                            Preview
                          </div>
                        ) : column === "availableNormalTimeSlots" ? (
                          <div
                            onClick={() =>
                              handlePreviewPopupDialogOpen(
                                data.availableNormalTimeSlots
                              )
                            }
                            className="clickable-text"
                          >
                            Preview
                          </div>
                        ) : column === "timeSlot" ? (
                          <div
                            onClick={() =>
                              handlePreviewPopupDialogOpen(data.timeSlot)
                            }
                            className="clickable-text"
                          >
                            Preview
                          </div>
                        ) : column === "users" ? (
                          data[column].length > 0 ? (
                            <div
                              onClick={() =>
                                handlePreviewPopupDialogOpen(data.users)
                              }
                              className="clickable-text"
                            >
                              Preview
                            </div>
                          ) : (
                            <div onClick={() => {}}>N/A</div>
                          )
                        ) : column === "availablePax" ||
                          column === "currentPax" ? (
                          <div
                            className={
                              data[column] >= Math.ceil(data["maxPax"] / 2)
                                ? "green-text"
                                : data[column] < Math.floor(data["maxPax"] / 4)
                                  ? "red-text"
                                  : "orange-text"
                            }
                          >
                            {data[column]}
                          </div>
                        ) : (
                          data[column]
                        )}
                      </td>
                    )
                )}
              </tr>
            ))
          )}
        </tbody>
      </table>
      <div className="pagination-controls">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <MdOutlineNavigateBefore />
        </button>
        {Array.from({ length: totalPages }, (_, index) => (
          <button
            key={index + 1}
            onClick={() => handlePageChange(index + 1)}
            className={currentPage === index + 1 ? "active" : ""}
          >
            {index + 1}
          </button>
        ))}
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <MdOutlineNavigateNext />
        </button>
      </div>
    </div>
  );
};
